export const en = {
  language: 'language',
  search: 'Search',
  mode: 'Mode',
  displayModes: 'Display Mode List',
  userInput: 'User Input',
  teacherLabel: 'For Teachers',
  searchModes: 'Search Mode',
  start: 'Start',
  restartConversation: 'Restart Conversation',
  tapToReply: 'Tap and write a reply',
  wordCount: 'words',
  imageToText: 'image ▷ text',
  printChat: 'Print this chat',
  submitChat: 'Submit this chat',
  submitRecord: 'Submit record (Trial operation)',
  home: 'Home',
  studentGuide: 'Student Guide',
  myPage: 'My page',
  manageModes: 'Manage Modes',
  confirmationForUsage: 'I have checked how to use it.',
  startChat: 'Start'
}
